import React, { useContext } from 'react';
import './Achievement.css';
import { ThemeContext } from '../../contexts/ThemeContext';
import { achievementData } from '../../data/achievementData';
import AchievementCard from './AchievementCard';
import achvmntImage from '../../assets/svg/achievement/achievement.avif';

function Achievement() {
    const { theme } = useContext(ThemeContext);
    const achievementFields = [...new Set(achievementData.achievements.map((item) => item.field))];

    return (
        <>
            {achievementData.achievements.length > 0 && (
                <div className="achievement" id="achievement" style={{ backgroundColor: theme.secondary }}>
                    <div className="achievement-shell">
                        <div className="achievement-card-wrapper">
                            <div className="achievement-description">
                                <p className="section-kicker">Achievements</p>
                                <h2 style={{ color: theme.primary }}>Recognitions & Professional Milestones</h2>
                                <p style={{ color: theme.tertiary80 }}>{achievementData.bio}</p>
                                <div className="achievement-highlights">
                                    {achievementFields.map((field) => (
                                        <span key={field}>{field}</span>
                                    ))}
                                </div>
                            </div>
                            <div className="achievement-visual">
                                <div className="achievement-img">
                                    <img src={achvmntImage} alt="Achievements" />
                                </div>
                                <div className="achievement-stat-card" style={{ background: theme.primary30, color: theme.tertiary }}>
                                    <strong>Impact Delivered</strong>
                                    <span>Celebrating certifications, leadership in Agile, and measurable delivery across modern platforms.</span>
                                </div>
                            </div>
                        </div>
                        <div className="achievement-cards">
                            {achievementData.achievements.map((achieve) => (
                                <AchievementCard
                                    key={achieve.id}
                                    id={achieve.id}
                                    title={achieve.title}
                                    details={achieve.details}
                                    date={achieve.date}
                                    field={achieve.field}
                                    image={achieve.image}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default Achievement
